
import { Container, Row, Col } from "react-bootstrap";
import { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../../asstes/styles/privateCouncilThreshold.scss";
import RequestPrivateAlignmentReview from "../RequestPrivateAlignmentReview";
gsap.registerPlugin(ScrollTrigger);

const PrivateCouncilThreshold = () => {
    const sectionRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {

            // Initial Blur Reveal
            gsap.from(".about-line", {
                opacity: 0,
                filter: "blur(1rem)",
                duration: 1.2,
                stagger: 0.15,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 75%",
                },
            });

            // Noteworthy Style Horizontal Motion
            ScrollTrigger.create({
                trigger: sectionRef.current,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: (self) => {
                    const move = self.progress * 2;

                    gsap.set(".line-1", {
                        xPercent: move,
                    });

                    gsap.set(".line-2", {
                        xPercent: -move,
                    });

                    gsap.set(".line-3", {
                        xPercent: move,
                    });
                },
            });

            // Blur & Fade when moving upward
            gsap.utils.toArray(".about-line").forEach((line) => {
                gsap.fromTo(
                    line,
                    {
                        opacity: 1,
                        filter: "blur(0px)",
                    },
                    {
                        opacity: 0.2,
                        filter: "blur(14px)",
                        ease: "none",
                        scrollTrigger: {
                            trigger: line,
                            start: "top 30%",
                            end: "top -20%",
                            scrub: true,
                        },
                    }
                );
            });

        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section
            className="home-page-new-about pd-common"
            ref={sectionRef}
        >
            <Container>
                <Row>
                    <Col className="mx-auto" lg={10}>
                        <div className="about-new-content">
                            <h2 className="about-text-title">
                                <div className="about-line line-1">
                                    <span className="fs-secondary">An invitation-only</span> space for those who stand at
                                </div>

                                <div className="about-line line-2">
                                    the edge of an irreversible decision — where
                                </div>

                                <div className="about-line line-3">
                                    consequence demands absolute
                                    <span className="fs-secondary"> clarity.</span>
                                </div>

                                 <h3 className="tag-line-name">Bhupendra Chaudhary </h3>
                            </h2> 
                            <div className="widget-btn-toolbar">
                                <a href="/alignment-review" className="widget-text-icon-btn">Request Private Alignment Review<i className="bi bi-arrow-right"></i></a>
                                {/* <a href="/" className="widget-text-icon-btn"></a> */}
                            </div>
                        </div>
                        <div className="trust-bar">
                            <div className="trust-item">
                                <span className="trust-dot"></span>
                                <span>Selected Engagements Only</span>
                            </div>

                            <div className="trust-divider"></div>

                            <div className="trust-item">
                                <span className="trust-dot"></span>
                                <span>Private Access</span>
                            </div>

                            <div className="trust-divider"></div>

                            <div className="trust-item">
                                <span className="trust-dot"></span>
                                <span>Confidential By Design</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default PrivateCouncilThreshold;